export interface ISystemConfig {
    id: number,
    configItemId: number,
    configItemDescription: string,
    entityType: number,
    entityTypeDescription: string,
    entityTypeId: number,
    value: string
}